import { render, staticRenderFns } from "./AltaConsultaCreditoV2.vue?vue&type=template&id=f1ec42fc"
import script from "./AltaConsultaCreditoV2.vue?vue&type=script&lang=js"
export * from "./AltaConsultaCreditoV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports